/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterKSmall = createReactComponent("outline", "letter-k-small", "IconLetterKSmall", [["path", { "d": "M10.5 8v8", "key": "svg-0" }], ["path", { "d": "M14.5 8l-3 4l3 4", "key": "svg-1" }], ["path", { "d": "M10.5 12h1", "key": "svg-2" }]]);

export { IconLetterKSmall as default };
//# sourceMappingURL=IconLetterKSmall.mjs.map
